<template>
  <div>
    <b-overlay
      :show="loading"
      opacity="0.7"
      spinner-variant="primary"
    >
      <b-container style="min-height: 100px;">
        <b-row class="justify-content-md-center">
          <b-col
            class="mt-4"
            cols="6"
            md="3"
            sm="4"
            v-for="bookItem in books"
            :key="bookItem.name"
          >
            <b-card
              :bg-variant="curId === bookItem.id ? 'primary' : ''"
              :text-variant="curId === bookItem.id ? 'white' : ''"
            >
              <div class="text-center book-title">
                {{ bookItem.name }}
              </div>

              <div class="text-center word-count">
                {{ bookItem.words.length }} 词
              </div>

              <b-progress
                class="mt-2"
                :value="bookItem.progress"
                max="100"
                height="12px"
                :variant="progressColor(bookItem.id, bookItem.progress)"
              ></b-progress>

              <b-button
                class="mt-2"
                :variant="curId === bookItem.id ? 'light' : 'outline-info'"
                size="sm"
                block
                v-b-modal.word-modal
                @click="handleView(bookItem)"
              >
                <b-icon-search></b-icon-search> 查看
              </b-button>
              <b-button
                class="mt-2"
                :variant="curId === bookItem.id ? 'warning' : 'outline-primary'"
                size="sm"
                block
                @click="handleMemorize(bookItem)"
              >
                <b-icon-lightning-charge></b-icon-lightning-charge> 背诵
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>

    <b-modal
      id="word-modal"
      :title="title"
      centered
      hide-footer
      :visible="modalStatus"
    >
      <b-input-group prepend="课号" class="mb-3">
        <b-form-select
          id="lno-select"
          :value="lNo"
          :options="lList"
          @change="handleLNoChange"
        ></b-form-select>
      </b-input-group>
      <b-table
        striped
        hover
        sticky-header="500px"
        :items="words.filter((wordItem) => wordItem.lno === lNo)"
        :fields="fields"
      ></b-table>
    </b-modal>
  </div>
</template>

<script>
import {
  addBook,
  openBook,
  isBookExist,
  getAllWords,
  getCurBook,
} from '@/utils/storage'
import { BOOKS, getBookData } from '@/services/api'
import ld from 'lodash'

export default {
  name: 'WordBasePage',
  
  data: () => ({
    loading: false,
    modalStatus: false,

    books: [],
    words: [],
    lList: [],
    lNo: '',
    curId: null,
    title: '',
    fields: [{
      key: 'id',
      label: 'id',
    }, {
      key: 'word',
      label: '单词',
    }, {
      key: 'oldWord',
      label: '传统拼写',
      thStyle: 'min-width: 90px',
    }, {
      key: 'expl',
      label: '翻译',
    }],
  }),

  created() {
    this.initBookInfo()
  },

  methods: {
    async initBookInfo() {
      this.curId = await getCurBook()

      this.loading = true
      for (let idx = 0; idx < BOOKS.length; idx += 1) {
        const bookItem = BOOKS[idx]
        const ret = await getBookData(bookItem.url)

        if (ret) {
          const addRet = await addBook(ret)
          if (addRet) {
            this.books.push(addRet)
          } else {
            this.showMsg('错误', '保存单词书数据失败')
          }
        } else {
          this.showMsg('错误', '获取数据失败')
        }
      }
      this.loading = false
    },
    async handleMemorize(bookItem) {
      const status = await isBookExist(bookItem.id)
      if (status) {
        await openBook(bookItem.id)
        this.$router.push('/index')
      } else {
        this.showMsg('提示', '单词书不存在，请刷新后重试')
      }
    },
    async handleView(bookItem) {
      const status = await isBookExist(bookItem.id)
      this.words = []
      this.lList = []

      if (status) {
        this.title = bookItem.name
        this.words = await getAllWords(bookItem.id)
        this.words.forEach((wordItem) => this.lList.push(wordItem.lno))
        this.lList = ld.uniq(this.lList)

        if (this.lList.length > 0) {
          this.lNo = this.lList[0]
        } else {
          this.lNo = ''
        }
      } else {
        this.showMsg('提示', '单词书不存在，请刷新后重试')
      }
    },
    handleLNoChange(res) {
      this.lNo = res
    },
    showMsg(title, msg) {
      this.$bvModal.msgBoxOk(msg, {
        title: title,
        size: 'sm',
        buttonSize: 'sm',
        okTitle: '确定',
        okVariant: 'secondary',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true,
      })
    },
    progressColor(id, progress) {
      let color = 'primary'
      
      if (this.curId === id) {
        if (progress == 100) {
          color = 'info'
        } else {
          color = 'warning'
        }
      } else {
        if (progress == 100) {
          color = 'success'
        } else {
          color = 'primary'
        }
      }

      return color
    },
  },
}
</script>

<style scoped lang="scss">
  .book-title {
    display: flex;
    min-height: 60px;
    justify-content: center;
    align-items: center;
  }

  .word-count {
    margin-top: 5px;
    color: #ccc;
  }
</style>
